import './Auth.css';
import { useNavigate } from 'react-router-dom';
import successfullicon from '../../Assets/Images/SuccessfulPasswordReset/successfullicon.png';

function SuccessfullRegistered(){
    const navigate = useNavigate();
    return(
        <>
             <div className='logincontainer'>
                    <form className='loginform' style={{width:"400px"}}>
                        <img src={successfullicon} alt="successfull" style={{marginTop:"20px"}} width="160" height="160"/>
                           <h2 style={{color:"#44c444"}}>Successful</h2>
                           <h3> Your phone number has been successfully registered</h3>
                           <section className='loginbuttons' style={{marginBottom:"35px",marginTop:"20px"}}>
                                <button className='loginbutton' style={{width:"200px"}}>LOGIN</button>
                            </section>
                    </form>
             </div>
        </>
        );

}

export default SuccessfullRegistered;